import { MainApiUrl } from "../../../../Imports/MainApiUrl";

const HdfcCollectNow = (obj, userData) => {
  function isDate(val) {
    // Cross realm comptatible
    return Object.prototype.toString.call(val) === "[object Date]";
  }

  function isObj(val) {
    return typeof val === "object";
  }

  function stringifyValue(val) {
    if (isObj(val) && !isDate(val)) {
      return JSON.stringify(val);
    } else {
      return val;
    }
  }
  function buildForm({ action, params }) {
    const form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", action);

    Object?.keys(params)?.forEach((key) => {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", key);
      input.setAttribute("value", stringifyValue(params[key]));
      form.appendChild(input);
    });
    return form;
  }

  const embeddedParams = {
    key_id: obj.key_id || obj.KEY_ID || obj?.key,
    amount: obj.amount || obj.TXN_AMOUNT,
    currency: obj?.currency || "INR",
    order_id: obj.order_id || obj.ORDER_ID || obj.orderId,
    name: "Quick Campus",
    description: "Payment for Order",
    image: "https://cdn.razorpay.com/logos/BUVwvgaqVByGp2_large.jpg",

    // Prefill Data
    "prefill[name]": userData.name || obj.name || "",
    "prefill[contact]":
      userData.contact ||
      userData.mobile ||
      obj.MOBILE_NO ||
      userData?.number ||
      obj?.number ||
      "",
    "prefill[email]": userData.email || obj.EMAIL || "",

    // Callback URLs
    callback_url: `${MainApiUrl}student/online-fee-payment`,
    cancel_url: `${MainApiUrl}home/student/transactionhistory`,
  };

  // 3. Build and Submit Form
  const form = buildForm({
    action: "https://api.razorpay.com/v1/checkout/embedded",
    params: embeddedParams,
  });

  document.body.appendChild(form);
  form.submit();
  form.remove();
  return;
};

export default HdfcCollectNow;
